module.exports = {
  breakpoints: {
    maxHD: "1920px",
    minHD: "1400px",
    maxLargeDesktop: "1399px",
    minLargeDesktop: "1200px",
    maxDesktop: "1199px",
    minDesktop: "992px",
    maxTablette: "991px",
    minTablette: "768px",
    maxMobile: "767px",
    minMobile: "351px",
    maxXsmall: "350px"
  },
  fonts: {
    black: 900,
    bold: 700,
    semiBold: 600,
    regular: 400,
    light: 300,
  },
  colors: {
    blue_ktb: "#002739",
    pink_ktb: "#e94268",
    green_ktb: "#a3ca68",
    turquoise_ktb: "#4ebdc5",
    grey_title: "#f1f1f1",
    grey_line: "#cdcdcd",
    grey_light: "#f8f8f8",
    pink_triangle: "#f66385",
    black_font: "#505f5c",
    blue_font: "#023c5a",
    lighten_pink_font: "#fb8fa7",
    lighten_blue_font: "#7792a1",
    greyblue_font: "#698998",
    blue_background_light: "#0e415d",
    blue_darker: "#003c58",
    pink_darker: "#d13b5d",
    what_blue: "#8faadc"
  }
};